/* eslint-disable max-len */

import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function Locate(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm8.94,3A8.994,8.994,0,0,0,13,3.06V2a1,1,0,0,0-2,0V3.06A8.994,8.994,0,0,0,3.06,11H2a1,1,0,0,0,0,2H3.06A8.994,8.994,0,0,0,11,20.94V22a1,1,0,0,0,2,0V20.94A8.994,8.994,0,0,0,20.94,13H22a1,1,0,0,0,0-2H20.94ZM12,19a7,7,0,1,1,7-7A6.995,6.995,0,0,1,12,19Z" />
    </SvgIcon>
  );
}

export default Locate;
